document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.logo-carousel-container').forEach(container => {
    const track = container.querySelector('.logo-track');
    if (!track) return;

    // Pause when out of viewport
    const observer = new IntersectionObserver(entries => {
      entries.forEach(e => {
        track.style.animationPlayState = e.isIntersecting ? 'running' : 'paused';
      });
    }, { threshold: 0.1 });
    observer.observe(container);
  });
});